// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Type_Image = require("../../type/Type_Image.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");

function make(imageKind) {
  if (typeof imageKind === "number") {
    switch (imageKind) {
      case /* AndroidReleases */0 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: /* LeftToRight */1,
                  presentation: "Cover",
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Unknow"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                        NAME: "Fluid",
                        VAL: undefined
                      }),
                  width: undefined
                };
      case /* Banner */1 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R4_1"),
                  size: Particle_Screen_Ds.make(undefined, {
                        NAME: "Fluid",
                        VAL: 120
                      }, {
                        NAME: "Fluid",
                        VAL: 192
                      }, {
                        NAME: "Fluid",
                        VAL: 300
                      }, undefined, {
                        NAME: "Fluid",
                        VAL: 80
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1400))
                };
      case /* Broadcast */2 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, {
                        NAME: "Custom",
                        VAL: [
                          170,
                          96
                        ]
                      }, undefined, undefined, undefined, {
                        NAME: "Custom",
                        VAL: [
                          114,
                          64
                        ]
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 400))
                };
      case /* BigTeaser */3 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, {
                        NAME: "Custom",
                        VAL: [
                          325,
                          183
                        ]
                      }, undefined, undefined, undefined, {
                        NAME: "Custom",
                        VAL: [
                          160,
                          90
                        ]
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 400))
                };
      case /* Contained */4 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Unknow"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Contained"),
                  width: undefined
                };
      case /* ContentCollection */5 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: /* BottomAndLeft */0,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, {
                        NAME: "Fluid",
                        VAL: 270
                      }, {
                        NAME: "Fluid",
                        VAL: 300
                      }, {
                        NAME: "Fluid",
                        VAL: 472
                      }, undefined, {
                        NAME: "Fluid",
                        VAL: 180
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1920))
                };
      case /* EventZone */6 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: "Cover",
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, {
                        NAME: "Fluid",
                        VAL: 253
                      }, {
                        NAME: "Fluid",
                        VAL: 237
                      }, {
                        NAME: "Fluid",
                        VAL: 305
                      }, undefined, {
                        NAME: "Fluid",
                        VAL: 180
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 720))
                };
      case /* Newsletter */7 :
          return {
                  background: Caml_option.some(Particle_Background_Ds.transparent),
                  color: undefined,
                  gradient: undefined,
                  presentation: "Cover",
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                        NAME: "Fluid",
                        VAL: undefined
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 720))
                };
      case /* PapaLandscape */8 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Contained"),
                  width: undefined
                };
      case /* Partner */9 :
          return {
                  background: undefined,
                  color: "Background",
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                        NAME: "Custom",
                        VAL: [
                          125,
                          70
                        ]
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 200))
                };
      case /* PortraitTeaser */10 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R2_3"),
                  size: Particle_Screen_Ds.make(undefined, {
                        NAME: "Custom",
                        VAL: [
                          235,
                          352
                        ]
                      }, {
                        NAME: "Custom",
                        VAL: [
                          265,
                          397
                        ]
                      }, undefined, undefined, {
                        NAME: "Custom",
                        VAL: [
                          128,
                          192
                        ]
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 300))
                };
      case /* PosterTeaser */11 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R3_4"),
                  size: Particle_Screen_Ds.make(undefined, {
                        NAME: "Custom",
                        VAL: [
                          150,
                          200
                        ]
                      }, {
                        NAME: "Custom",
                        VAL: [
                          189,
                          252
                        ]
                      }, undefined, undefined, {
                        NAME: "Custom",
                        VAL: [
                          132,
                          176
                        ]
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 600))
                };
      case /* PresseTopTeaser */12 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: "Cover",
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Contained"),
                  width: undefined
                };
      case /* PromotionalLogo */13 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Unknow"),
                  size: Particle_Screen_Ds.make(undefined, undefined, {
                        NAME: "Custom",
                        VAL: [
                          42,
                          42
                        ]
                      }, undefined, undefined, {
                        NAME: "Custom",
                        VAL: [
                          26,
                          26
                        ]
                      }),
                  width: undefined
                };
      case /* Square */14 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R1_1"),
                  size: Particle_Screen_Ds.make(undefined, {
                        NAME: "Custom",
                        VAL: [
                          190,
                          190
                        ]
                      }, undefined, undefined, undefined, {
                        NAME: "Custom",
                        VAL: [
                          125,
                          125
                        ]
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 200))
                };
      case /* StandardTeaser */15 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, {
                        NAME: "Custom",
                        VAL: [
                          265,
                          148
                        ]
                      }, undefined, undefined, undefined, {
                        NAME: "Custom",
                        VAL: [
                          128,
                          72
                        ]
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 400))
                };
      case /* ThumbnailLandscape */16 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                        NAME: "Custom",
                        VAL: [
                          135,
                          75
                        ]
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 400))
                };
      case /* TopSquareTeaser */17 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: /* BottomAndLeft */0,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R1_1"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                        NAME: "Fluid",
                        VAL: undefined
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 940))
                };
      case /* TopTeaser */18 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: /* BottomAndLeft */0,
                  presentation: "Cover",
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                        NAME: "Fluid",
                        VAL: undefined
                      }),
                  width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1920))
                };
      
    }
  } else {
    switch (imageKind.TAG | 0) {
      case /* DangerousHtml */0 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Unknow"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "FullAuto"),
                  width: undefined
                };
      case /* FromCdn */1 :
          var image = imageKind._0;
          if (typeof image === "number") {
            switch (image) {
              case /* AfterRightVOD */0 :
                  return {
                          background: undefined,
                          color: undefined,
                          gradient: undefined,
                          presentation: undefined,
                          ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Unknow"),
                          size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                NAME: "Custom",
                                VAL: [
                                  126,
                                  91
                                ]
                              }),
                          width: undefined
                        };
              case /* Error500 */2 :
                  return {
                          background: undefined,
                          color: undefined,
                          gradient: undefined,
                          presentation: undefined,
                          ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Unknow"),
                          size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "FullAuto"),
                          width: undefined
                        };
              case /* EuropeanFlag */3 :
                  return {
                          background: undefined,
                          color: undefined,
                          gradient: undefined,
                          presentation: undefined,
                          ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Unknow"),
                          size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                NAME: "Custom",
                                VAL: [
                                  166,
                                  56
                                ]
                              }),
                          width: undefined
                        };
              case /* Background500 */1 :
              case /* NewsletterZone */4 :
                  break;
              case /* User */5 :
                  return {
                          background: undefined,
                          color: undefined,
                          gradient: undefined,
                          presentation: undefined,
                          ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R1_1"),
                          size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                NAME: "Custom",
                                VAL: [
                                  200,
                                  200
                                ]
                              }),
                          width: undefined
                        };
              
            }
          } else {
            switch (image.TAG | 0) {
              case /* Badge */0 :
                  return {
                          background: undefined,
                          color: undefined,
                          gradient: undefined,
                          presentation: undefined,
                          ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Unknow"),
                          size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                NAME: "Custom",
                                VAL: [
                                  130,
                                  40
                                ]
                              }),
                          width: undefined
                        };
              case /* BuyProgram */1 :
                  return {
                          background: undefined,
                          color: undefined,
                          gradient: undefined,
                          presentation: undefined,
                          ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Unknow"),
                          size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                NAME: "Custom",
                                VAL: [
                                  159,
                                  111
                                ]
                              }),
                          width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 159))
                        };
              case /* Newsletter */2 :
                  return {
                          background: undefined,
                          color: undefined,
                          gradient: undefined,
                          presentation: "Cover",
                          ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                          size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                NAME: "Fluid",
                                VAL: undefined
                              }),
                          width: undefined
                        };
              case /* Profile */3 :
                  return {
                          background: undefined,
                          color: undefined,
                          gradient: undefined,
                          presentation: "Cover",
                          ratio: image._0 ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R9_16") : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                          size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                NAME: "Fluid",
                                VAL: undefined
                              }),
                          width: undefined
                        };
              
            }
          }
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Unknow"),
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                        NAME: "Fluid",
                        VAL: undefined
                      }),
                  width: undefined
                };
      case /* TeaserGuide */2 :
          if (imageKind._0) {
            return {
                    background: undefined,
                    color: undefined,
                    gradient: undefined,
                    presentation: undefined,
                    ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                    size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Contained"),
                    width: Caml_option.some(Particle_Screen_Ds.make(undefined, 720, undefined, 400, undefined, 400))
                  };
          } else {
            return {
                    background: undefined,
                    color: undefined,
                    gradient: undefined,
                    presentation: undefined,
                    ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                    size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Contained"),
                    width: Caml_option.some(Particle_Screen_Ds.make(undefined, 400, undefined, 200, 400, 200))
                  };
          }
      case /* TeaserHover */3 :
          if (imageKind._0 >= 2) {
            return {
                    background: undefined,
                    color: undefined,
                    gradient: undefined,
                    presentation: undefined,
                    ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                    size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                          NAME: "Custom",
                          VAL: [
                            410,
                            232
                          ]
                        }),
                    width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 400))
                  };
          } else {
            return {
                    background: undefined,
                    color: undefined,
                    gradient: undefined,
                    presentation: undefined,
                    ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                    size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                          NAME: "Custom",
                          VAL: [
                            344,
                            195
                          ]
                        }),
                    width: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 400))
                  };
          }
      case /* WithCaption */4 :
          return {
                  background: undefined,
                  color: undefined,
                  gradient: undefined,
                  presentation: undefined,
                  ratio: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "R16_9"),
                  size: Belt_Option.getWithDefault(imageKind._0, Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                            NAME: "Fluid",
                            VAL: undefined
                          })),
                  width: imageKind._1
                };
      
    }
  }
}

function view(param) {
  return {
          background: param.background,
          color: param.color,
          gradient: param.gradient,
          presentation: param.presentation,
          ratio: Type_Image.RatioResponsive.make(param.ratio),
          size: param.size,
          width: param.width
        };
}

exports.make = make;
exports.view = view;
/* No side effect */
